import {Listener} from 'yougile-util'

export const sharedBoardsEvents = new Listener<() => void>()
